import { z } from "zod";

export enum DistanceUnit {
  KILOMETERS = "km",
  MILES = "mi",
  METERS = "m",
  FEET = "ft",
}

export type Distance = {
  unit: DistanceUnit;
  value: number;
};

export const DistanceSchema = z.object({
  unit: z.nativeEnum(DistanceUnit),
  value: z.number().nonnegative(),
});
